/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Link_Dialog_WaitingInputs */

const he_account_delivery_whatsapp_link_dialog_waiting = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ממתינים שתשלחו את ההודעה...`)
};

const en_account_delivery_whatsapp_link_dialog_waiting = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for you to send the message...`)
};

/**
* | output |
* | --- |
* | "Waiting for you to send the message..." |
*
* @param {Account_Delivery_Whatsapp_Link_Dialog_WaitingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_link_dialog_waiting = /** @type {((inputs?: Account_Delivery_Whatsapp_Link_Dialog_WaitingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Link_Dialog_WaitingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_link_dialog_waiting(inputs)
	return en_account_delivery_whatsapp_link_dialog_waiting(inputs)
});